import React from 'react';
import {RestorePasswordForm} from 'components/restore-password';
import {MasterLayout} from 'components/layouts';
import title from 'constants/TitlePages.js';

class RestorePasswordPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.RestorePasswordPage;
  }

  render() {
    return (
      <MasterLayout>
        <RestorePasswordForm />
      </MasterLayout>
    );
  }
}

export default RestorePasswordPage;



// WEBPACK FOOTER //
// ./pages/restore-password/RestorePasswordPage.jsx